<script setup lang="ts">
withDefaults(defineProps<{ value?: number | null; indeterminate?: boolean }>(), {
  value: null,
  indeterminate: false,
});
</script>

<template>
  <div class="prog" role="progressbar">
    <div
      v-if="!indeterminate && value !== null"
      class="prog__fill"
      :style="{ width: `${Math.max(0, Math.min(100, value))}%` }"
    />
    <div v-else class="prog__indet" />
  </div>
</template>

<style scoped>
.prog {
  width: 100%;
  height: 4px;
  background: var(--bg-overlay);
  border-radius: var(--r-full);
  overflow: hidden;
  position: relative;
}
.prog__fill {
  height: 100%;
  background: var(--accent);
  transition: width 0.4s ease-out;
  box-shadow: 0 0 12px var(--accent-glow);
}
.prog__indet {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--accent) 50%,
    transparent 100%
  );
  background-size: 40% 100%;
  animation: indet 1.4s linear infinite;
}
@keyframes indet {
  0%   { background-position: -40% 0; }
  100% { background-position: 140% 0; }
}
</style>
